import React from 'react';

/**
 * CertRightImage
 * 
 * Displays the right image for the Certification section.
 * Applies conditional CSS classes based on the treatment prop,
 * mimicking legacy MainRight.js behavior.
 */
export const CertRightImage = ({ treatment }) => {
  let className = "il-add";
  // Mimic MainRight's IlAdd case "cr" for conditional classes
  // The original MainRight had:
  // !props.tr -> oeko-text-standard
  // props.tr -> treated
  if (treatment) { // if treatment exists
    className += " treated"; // Add 'treated' class
  } else {
    className += " oeko-text-standard"; // Add 'oeko-text-standard' class if no treatment
  }

  return (
    <div className={className} lower="right" data-beta-flow="true" style={{ backgroundImage: `url("/img/cert/cert-right.jpeg")` }}></div>
  );
};
